import React, { useState, useEffect } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { Container } from 'reactstrap'
import moment from 'moment'
import 'moment/locale/fr'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import 'containers/Time/Components/Calendar.scss'
import Year from './Year'
import YearEvent from 'containers/Time/Components/YearEvent'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'

const DnDCalendar = withDragAndDrop(Calendar)
const allEvents = []

const CalendarView = ({ id = false, page }) => {
  const [finalEvents, setFinalEvents] = useState(allEvents)
  const [defaultView, setDefaultView] = useState('year')

  const createFixedEvents = (events, categoryDD) => {
    const fEvents = events.filter((x) => x.event_type === 'f')
    fEvents.forEach((e) => {
      if (e.years) {
        const startDate = new Date(`${e.day_num}-${e.month_num}-${e.years}`)
        e.start = startDate
        allEvents.push(e)
      } else {
        const startYear = 2000
        const lastYear = 2030
        // make events for all years in range 2000-2030
        for (let i = startYear; i < lastYear; i++) {
          let d = `${i}-${e.day_num}-${e.month_num}`
          let ed = `${i}-${e.day_num}-${e.month_num}`
          let cat = categoryDD.find((x) => x.id === e.category_id)
          let catName = (cat && cat.name) || ''
          let type = cat && cat.type.find((x) => x.id.toString() === e.type_id)
          let typeName = (type && type.name) || ''

          let event = {
            start: new Date(d),
            startDate: new Date(d),
            isAllDay: true,
            end: new Date(ed),
            endDate: new Date(ed),
            title: e.titre,
            location: e.lieux,
            type: typeName,
            category: catName,
            event_type: e.event_type,
            pays: e.pays,
            designation: e.designation,
            region: e.region,
          }
          allEvents.push(event)
        }
      }
    })
  }

  const getAllEvents = async () => {
    let url = `${
      urls.crudEntretienRealiserOperations + `?vid=${id}&Done=false&page=${page}&Schedule=Oui`
    }`
    // const { data = [] } = await makeGetRequest('/api/time/get-events',{},true)
    const res = await makeGetRequest(url, {}, true)

    // const response = await makeGetRequest(url, {}, false)
    // if (response.status === 200) {
    //   setOperations({ ...response.data })
    //   // setLoading(false)
    // }

    const { data: categoryDD } = await makeGetRequest('/api/time/get-category-dd', {}, true)
    const eventsall = []
    res.data.results.filter((x) => eventsall.push(x.Event))

    const events = eventsall
    // filter appointment events
    const customEvents = events.filter((x) => x.event_type === 'a')

    customEvents.forEach((event) => {
      let sDate = event.start_date ? event.start_date.substring(0, 2) : ''
      let sMonth = event.start_date ? event.start_date.substring(3, 5) : ''
      let sYear = event.start_date ? event.start_date.substring(6, 10) : ''

      const startDate = new Date(
        `${sMonth}-${sDate}-${sYear}
           ${event.start_time || '00:01'}`,
      )

      let eDate = event.end_date ? event.end_date.substring(0, 2) : ''
      let eMonth = event.end_date ? event.end_date.substring(3, 5) : ''
      let eYear = event.end_date ? event.end_date.substring(6, 10) : ''

      const endDate = new Date(
        `${eMonth}-${eDate}-${eYear}
          ${event.end_time || '23:59'}`,
      )

      let cat = categoryDD.find((x) => x.id === event.category_id)
      let catName = (cat && cat.name) || ''
      let type = cat && cat.type.find((x) => x.id.toString() === event.type_id)
      let typeName = (type && type.name) || ''

      event.title = event.titre
      event.start = startDate
      event.end = endDate
      event.startTime = event.start_time
      event.endTime = event.end_time
      event.location = event.lieux
      event.isAllDay = event.is_all_day
      event.type = typeName
      event.category = catName
      allEvents.push(event)
    })
    createFixedEvents(events, categoryDD)
    setFinalEvents(allEvents)
    setDefaultView('year')
  }

  useEffect(() => {
    getAllEvents()
  }, [finalEvents])

  const localizer = momentLocalizer(moment) // or globalizeLocalizer
  localizer.formats.yearHeaderFormat = 'YYYY'
  // const [showModal, setShowModal] = useState(false)
  // const toggleModal = useCallback(() => {
  //   setShowModal(!showModal)
  // })

  // const eventPropGetter = useCallback((event, start, end, isSelected) => {
  //   const border = getColor(event.type)
  //   var style = {
  //     borderRadius: '6px',
  //     border: `px solid ${getColor(event.type)}`,
  //     borderLeft: `10px solid ${border}`,
  //     fontWeight: '400',
  //     fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  //     backgroundColor: event.event_type === 'f' ? '#d86565' : '#adb9ca',
  //   }
  //   return {
  //     style: style,
  //     className: event.type.toLowerCase(),
  //   }
  // })

  // const onDropEvent = async (props) => {
  //   const { event, start, end } = props
  //   let sDate = start ? start.getDate() : ''
  //   let sMonth = start ? start.getMonth() + 1 : ''
  //   let sYear = start ? start.getFullYear() : ''
  //   let sHour = start ? start.getHours() : ''
  //   let sMinute = start ? start.getMinutes() : ''

  //   const startDate = `${sYear}-${sMonth}-${sDate}`

  //   event.start_date = startDate
  //   event.start_time = `${sHour}:${sMinute}`

  //   let eDate = end ? end.getDate() : ''
  //   let eMonth = end ? end.getMonth() + 1 : ''
  //   let eYear = end ? end.getFullYear() : ''
  //   let eHour = start ? end.getHours() : ''
  //   let eMinute = start ? end.getMinutes() : ''

  //   const endDate = `${eYear}-${eMonth}-${eDate}`

  //   event.end_date = endDate
  //   event.end_time = `${eHour}:${eMinute}`

  //  makePutRequest(`/api/time/events/${event.id}/`, event,{},true)
  //     .then(function () {
  //       window.location.reload()
  //     })
  //     .catch(function (error) {

  //     })
  // }

  // const onClickSlot = (slot) => {
  //   setSlot(slot)
  //   setShowModal(slot)
  // }

  return (
    <>
      <div
        style={{
          backgroundColor: '#00001D',
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        }}
      >
        <Container
          className="scheduler-container"
          style={{ backgroundColor: '#00001D', color: 'white' }}
        >
          {/* <Button
            className="create-btn"
            onClick={() => {
              toggleModal()
            }}
          >
            Créer
          </Button> */}
          <br />
          <DnDCalendar
            culture={'fr'}
            dayLayoutAlgorithm={'no-overlap'}
            defaultView={defaultView}
            // style={{ height: 800 }}
            // selectable={true}
            longPressThreshold={10}
            // draggableAccessor={() => true}
            // onSelectSlot={(slot) => onClickSlot(slot)}
            // onEventDrop={(props) => onDropEvent(props)}
            // onEventResize={(props) => onDropEvent(props)}
            timeslots={1}
            step={60}
            localizer={localizer}
            events={finalEvents}
            toolbar={true}
            views={{
              // day: true,
              // week: true,
              // month: true,
              // agenda: true,
              year: Year,
            }}
            components={{
              // month: { event: MonthEvent },
              // week: { event: Event },
              // day: { event: Event },
              year: { event: YearEvent },
              // agenda: { event: CustomAgendaEvent },
            }}
            messages={{
              previous: '<',
              next: '>',
              today: "Aujourd'hui",
              // month: 'Mois',
              // week: 'semaine',
              // day: 'jour',
              // agenda: 'ordre du jour',
              year: 'Annee',
            }}
            // eventPropGetter={eventPropGetter}
            // formats={{
            //   dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
            //     localizer.format(start, 'D', culture) +
            //     ' - ' +
            //     localizer.format(end, 'D MMMM YYYY', culture),
            //   dayHeaderFormat: (date, culture, localizer) =>
            //     localizer.format(date, 'dddd D MMMM YYYY', culture),
            // }}
          />
        </Container>
        {/* {showModal && (
          <FormModal
            isOpen={showModal}
            getAllEvents={getAllEvents}
            toggleModal={toggleModal}
            title={'Rendez-vous'}
            slot={slot}
          />
        )} */}
      </div>
    </>
  )
}

export default CalendarView
